module.exports = __webpack_public_path__ + "img/lg_ring_r_c_null_0@3x.be5792f1.png";